import {
 
  SET_CARGO_DETAILS_TYPES_LIST,
  SET_CARGO_MATERIAL_PACKING_TEMAPLATE,
  SET_CONSIGNOR_PICKUP_LOCATION_LIST,
  SET_HANDLING_INSTRUCTION_TYPES_LIST,
  SET_PACKING_TYPES_LIST,
  SET_SERVICE_MODE_TYPES_LIST,
  SET_SERVICE_TYPES_LIST,
  SET_VEHICLE_TYPES_LIST,
} from "Constants/actionConstants";
import {

  CREATE_SUPPLIER_CONTRACT_URL,
  DELETE_SUPPLIER_CONTRACT_RFQ_DETAILS_URL,
  DOWNLOAD_FILE_URL,
  GET_CARGO_DETAILS_TYPES_LIST_URL,
  GET_CARGO_MATERIAL_PACKING_TEMAPLATE_URL,
  GET_CONSIGNOR_PICKUP_LOCATION_LIST_URL,
  GET_HANDLING_INSTRUCTION_TYPES_LIST_URL,
  GET_PACKING_TYPES_LIST_URL,
  GET_SERVICE_MODE_TYPES_LIST_URL,
  GET_SERVICE_TYPES_LIST_URL,
  GET_VEHICLE_TYPES_LIST_URL,
  UPDATE_SUPPLIER_CONTRACT_DETAILS_URL,
  UPLOAD_CARGO_MATERIAL_PACKING_TEMAPLATE_URL,
  getDataWithToken,
} from "Utils/api";
import axiosT1 from "Utils/axios";
import { call, put } from "redux-saga/effects";
import { getUser } from "Utils/storage";
import { getItemFromLocal } from "Utils/localStorage";

export function* getConsignorPickupLocationList(action) {
  try {
    const resData = yield call(
      axiosT1.get,
      GET_CONSIGNOR_PICKUP_LOCATION_LIST_URL
    );
    console.log("resData:", resData);
    let consignorPickupLocationList = resData.data.data || [];
    consignorPickupLocationList = consignorPickupLocationList.map((ele) => {
      const newObject = {
        ...ele,
        label: ele.source,
        value: ele.pin_code,
      };
      return newObject;
    });

    yield put({
      type: SET_CONSIGNOR_PICKUP_LOCATION_LIST,
      payload: consignorPickupLocationList,
    });
  } catch (e) {
    console.log("e:", e);
  }
}

export function* getServiceTypesList(action) {
  try {
    const resData = yield call(axiosT1.get, GET_SERVICE_TYPES_LIST_URL);

    let serviceTypesList = resData.data.data || [];

    yield put({
      type: SET_SERVICE_TYPES_LIST,
      payload: serviceTypesList,
    });
  } catch (e) {
    console.log("e:", e);
  }
}

export function* getServiceModeTypesList(action) {
  try {
    const resData = yield call(axiosT1.get, GET_SERVICE_MODE_TYPES_LIST_URL, {
      params: action.queryParams,
    });

    let serviceModeTypesList = resData.data.data || [];

    yield put({
      type: SET_SERVICE_MODE_TYPES_LIST,
      payload: serviceModeTypesList,
    });
  } catch (e) {
    console.log("e:", e);
  }
}

export function* getCargoDetailsTypesList(action) {
  try {
    const resData = yield call(axiosT1.get, GET_CARGO_DETAILS_TYPES_LIST_URL );
   

    let cargoDetailsTypesList = resData.data.data || [];

    yield put({
      type: SET_CARGO_DETAILS_TYPES_LIST,
      payload: cargoDetailsTypesList,
    });
  } catch (e) {
    console.log("e:", e);
  }
}

export function* getCargoMaterialPackingTemaplate(action) {
  try {
    const resData = yield call(axiosT1.get, GET_CARGO_MATERIAL_PACKING_TEMAPLATE_URL);

    const fileName = resData.data.data.link || "";

    yield put({
      type: SET_CARGO_MATERIAL_PACKING_TEMAPLATE,
      payload: fileName,
    });

    if (fileName && action.shouldDownload) {
      const user = getUser();
      const presignedUrlParams = {
        fileName,
        companyId: user?.companyId,
        seekerCompanyId: getItemFromLocal("transporter_seeker_company_id"),
      };
      const presignedData = yield call(getDataWithToken, DOWNLOAD_FILE_URL, presignedUrlParams);
      if (presignedData?.url) {
        const link = document.createElement("a");
        link.href = presignedData.url;
        link.setAttribute("download", true);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  } catch (e) {
    console.log("e:", e);
  }
}


export function* uploadCargoMaterialPackingTemaplate(action) {
  try {
    const resData = yield call(
      axiosT1.post,
      UPLOAD_CARGO_MATERIAL_PACKING_TEMAPLATE_URL,
      action.payload
    );
    const materialPackingList = resData.data.data.material_packing_list || [];
    if (!!action.onSuccess) {
      action.onSuccess(materialPackingList);
    }
  } catch (e) {
    console.log("e:", e);
  }
}

export function* getHandlingInstructionTypesList(action) {
  try {
    const resData = yield call(axiosT1.get, GET_HANDLING_INSTRUCTION_TYPES_LIST_URL );
    let handlingInstructionTypesList = resData.data.data || [];

    yield put({
      type: SET_HANDLING_INSTRUCTION_TYPES_LIST,
      payload: handlingInstructionTypesList,
    });
  } catch (e) {
    console.log("e:", e);
  }
}


export function* getVehicleTypesList(action) {
  try {
    const resData = yield call(axiosT1.get, GET_VEHICLE_TYPES_LIST_URL ,{
      params: action.queryParams
    });
    let vehicleTypesList = resData.data.data || [];
    vehicleTypesList = vehicleTypesList.map((ele) => {
      const newObject = {
        ...ele,
        label: ele.name,
        value: ele.id,
      };
      return newObject;
    });
    
    yield put({
      type: SET_VEHICLE_TYPES_LIST,
      payload: vehicleTypesList,
    });
  } catch (e) {
    console.log("e:", e);
  }
}



export function* createSupplierContract(action) {
  try {
    const resData = yield call(axiosT1.post, CREATE_SUPPLIER_CONTRACT_URL , action.payload);
    if(!!action.onSuccess){
      action.onSuccess(resData.data)
    }
  } catch (e) {
    console.log("e:", e);
  }
}


export function* getPackingTypesList(action) {
  try {
    const resData = yield call(
      axiosT1.get,
     GET_PACKING_TYPES_LIST_URL,
     {
      params: action.queryParams
     }
     );

    let packingTypesList = resData.data.data || [];
    packingTypesList = packingTypesList.map((ele) => {
      const newObject = {
        ...ele,
        label: ele.name,
        value: ele.id,
      };
      return newObject;
    });
    
    yield put({
      type: SET_PACKING_TYPES_LIST,
      payload: packingTypesList,
    });
  } catch (e) {
    console.log("e:", e);
  }
}

export function* updateSupplierContractDetails(action) {
  try {
    const resData = yield call(axiosT1.put, UPDATE_SUPPLIER_CONTRACT_DETAILS_URL,action.payload);
    if(!!action.onSuccess){
      action.onSuccess(resData.data)
    }
  } catch (e) {
    console.log("e:", e);
  }
}

export function* deleteSupplierContractRfqDetails(action) {
  try {
    const resData = yield call(axiosT1.delete,
       DELETE_SUPPLIER_CONTRACT_RFQ_DETAILS_URL,
       {
        params:action.queryParams
       });
    if(!!action.onSuccess){
      action.onSuccess(resData.data)
    }
  } catch (e) {
    console.log("e:", e);
  }
}
